import axios from 'axios';

export let config = {
  apiUrl: 'http://localhost:8011/v1',
  // apiUrl: 'https://api.dev.smarterproctoring.com/v1',
  // apiUrl: 'https://api.stage.smarterproctoring.com/v1',
  // apiUrl: 'https://api.smarterproctoring.com/v1',
  domain: 'http://localhost:3001'
}

// Flag local development
if (!process.env.REACT_APP_ENVIRONMENT) {
  sessionStorage.setItem('local', true);
}

// Dev
if (process.env.REACT_APP_ENVIRONMENT === 'dev') {
  config.apiUrl = 'https://api.dev.smarterproctoring.com/v1';
  config.domain = 'http://playback.dev.smarterproctoring.com'
}

// Stage
if (process.env.REACT_APP_ENVIRONMENT === 'stage') {
  config.apiUrl = 'https://api.stage.smarterproctoring.com/v1';
  config.domain = 'http://playback.stage.smarterproctoring.com'
}

// Production
if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  config.apiUrl = 'https://api.smarterproctoring.com/v1';
  config.domain = 'http://playback.smarterproctoring.com'
}

export let api = axios.create({
  baseURL: config.apiUrl
});

export function setToken(token) {
  api = axios.create({
    baseURL: config.apiUrl,
    headers: { token }
  });
}